/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
var _0x573d=['bool','uint32','Position','description'];(function(_0x3e53a5,_0x573df5){var _0x15b6ac=function(_0x4e0e9d){while(--_0x4e0e9d){_0x3e53a5['push'](_0x3e53a5['shift']());}};_0x15b6ac(++_0x573df5);}(_0x573d,0x16a));var _0x15b6=function(_0x3e53a5,_0x573df5){_0x3e53a5=_0x3e53a5-0x0;var _0x15b6ac=_0x573d[_0x3e53a5];return _0x15b6ac;};import _0x51be83 from'./operationcompressor';export default class p extends _0x51be83{static get[_0x15b6('0x1')](){return{'fields':{'sourcePosition':{'type':_0x15b6('0x0'),'id':0x1},'targetPosition':{'type':'Position','id':0x2},'graveyardPosition':{'type':_0x15b6('0x0'),'id':0x3},'howMany':{'type':_0x15b6('0x3'),'id':0x4},'wasUndone':{'type':_0x15b6('0x2'),'id':0x5}}};}}